import { render, staticRenderFns } from "./GrowerBrokerInvoice.vue?vue&type=template&id=10d48902"
import script from "./GrowerBrokerInvoice.vue?vue&type=script&lang=js"
export * from "./GrowerBrokerInvoice.vue?vue&type=script&lang=js"
import style0 from "./GrowerBrokerInvoice.vue?vue&type=style&index=0&id=10d48902&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports